import { styled } from "@mui/material"
import React from "react"

const TransferListTable: React.FC<{
  transferList: {
    quantity: number
    productId?: string | null
    productSecondaryId?: number | null
    productName: string | null | undefined
  }[]
}> = ({ transferList }) => {
  return (
    <div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "var(--slipBorder)", border: "1px solid var(--slipBorder)" }}>
            <StyledTh>#</StyledTh>
            <StyledTh>Product ID</StyledTh>
            <StyledTh>Product</StyledTh>
            <StyledTh>Quantity</StyledTh>
          </tr>
        </thead>
        <tbody>
          {transferList.map((row, index) => (
            <tr key={index} style={{ border: "1px solid var(--slipBorder)" }}>
              <StyledTd>{index + 1}</StyledTd>
              <StyledTd>{row.productSecondaryId}</StyledTd>
              <StyledTd>{row.productName}</StyledTd>
              <StyledTd>{row.quantity}</StyledTd>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

const StyledTh = styled("th")(({ theme }) => ({
  fontWeight: 600,
  padding: "8px",
  textAlign: "center",
  border: `1px solid var(--slipBorder)`,
  color: "var(--slipColor)",
  fontSize: theme.typography.subtitle1.fontSize
}))

const StyledTd = styled("td")(({ theme }) => ({
  fontWeight: 400,
  padding: "8px",
  textAlign: "center",
  border: `1px solid var(--slipBorder)`,
  color: "var(--slipColor)",
  fontSize: theme.typography.subtitle1.fontSize
}))
export default TransferListTable
